import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
const BACKEND_API_URL = process.env.REACT_APP_API_URL;

export const getApiUrl = () => {
  return sessionStorage.getItem("api_url") || BACKEND_API_URL;
};

const useSessionStorage = (key, defaultValue) => {
  const [value, setValue] = useState(
    sessionStorage.getItem(key) || defaultValue
  );

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === key) {
        setValue(event.newValue || defaultValue);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [key, defaultValue]);

  return value;
};

export const useApiUrl = () => {
  return useSessionStorage("api_url", BACKEND_API_URL);
};

export const API_URL = getApiUrl();

const SetApiUrl = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const url = searchParams.get("apiUrl");
    const project = searchParams.get("project");

    if (url) {
      const currentApiUrl = sessionStorage.getItem("api_url");
      if (currentApiUrl !== url) {
        sessionStorage.setItem("api_url", url);
        // Cookies.remove("test_engine_project");
        Cookies.remove("test_engine_token");
        localStorage.removeItem("currentSectionIndexs");
        sessionStorage.removeItem("remainingTime");
        localStorage.removeItem("isRunning");
        localStorage.removeItem("startTimestamp");
        localStorage.removeItem("lastActive");
        sessionStorage.removeItem("visitedQuestions");
        sessionStorage.removeItem("cachedQuestionImage");
        sessionStorage.removeItem("candidate_details");
        sessionStorage.removeItem("candidate_exam_details");
        sessionStorage.removeItem("lastUpdatedIndex");
        sessionStorage.removeItem("remainingTime");
        sessionStorage.removeItem("examEnded");
        sessionStorage.removeItem("isEarlyMovedSection");
        sessionStorage.removeItem("updatedQuestionsList");
        sessionStorage.removeItem("activeSection");
        sessionStorage.removeItem("examEndTime");
        sessionStorage.removeItem("examStartTime");
        // localStorage.removeItem("assignedProctor");
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete("apiUrl");
        window.location.href = newUrl.toString();
      }
    }

    if (project) {
      sessionStorage.removeItem("api_url");
      sessionStorage.removeItem("hasReloaded");
      Cookies.remove("test_engine_token");
      sessionStorage.removeItem("visitedQuestions");
      sessionStorage.removeItem("venue");
      sessionStorage.removeItem("cachedQuestionImage");
      sessionStorage.removeItem("candidate_details");
      sessionStorage.removeItem("candidate_exam_details");
      sessionStorage.removeItem("lastUpdatedIndex");
      sessionStorage.removeItem("remainingTime");
      sessionStorage.removeItem("examEnded");
      sessionStorage.removeItem("isEarlyMovedSection");
      localStorage.removeItem("currentSectionIndexs");
      sessionStorage.removeItem("remainingTime");
      localStorage.removeItem("isRunning");
      localStorage.removeItem("startTimestamp");
      sessionStorage.removeItem("updatedQuestionsList");
      sessionStorage.removeItem("activeSection");
      sessionStorage.removeItem("examEndTime");
      sessionStorage.removeItem("examStartTime");
      localStorage.removeItem("lastActive");
      // localStorage.removeItem("assignedProctor");
    }
  }, [searchParams]);

  return null;
};

export default SetApiUrl;
